<template>
  <section class="content">
    <div class="flex justify-content-center">
      <div class="w-100 card">
        <div class="card-body">
          <div class="row form-horizontal mb-3" style="row-gap: 15px;">
            <div class="col-auto">
              <label class="control-label my-2 font-weight-normal">Filter tanggal :</label>
            </div>
            <div class="col-auto">
                <div class="input-group">
                    <input type="text" ref="daterange" class="form-control" style="border-right: 0" />
                    <div class="input-group-append">
                        <div class="input-group-text" style="background-color: #fff">
                            <span><span class="fa fa-calendar"></span></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <select class="form-control" v-model="filter.status_approval" @change="onDate">
                    <option value="" disabled selected>Status Approval</option>
                    <option value="1">Approve</option>
                    <option value="2">Request</option>
                    <option value="3">Reject</option>
                    <option value="0">Semua</option>
                </select>
            </div>
            <div class="col-auto">
              <select class="form-control" v-model="filter.shipper_type" @change="onDate">
                <option value="" selected disabled hidden>Tipe Shipper</option>
                <option value="0">bosCOD</option>
                <option value="1">bosAgen</option>
              </select>
            </div>
          </div>
          <div class="table-ticket">
            <table class="table table-hover" ref="tblverif" id="tblverif">
              <thead>
                <tr>
                  <th>ID SHIPPER</th>
                  <th>NIK</th>
                  <th>NAMA LENGKAP</th>
                  <th>NO. TELEPON</th>
                  <th>EMAIL</th>
                  <th>TANGGAL PENGAJUAN</th>
                  <th>STATUS APPROVAL</th>
                  <th>TINDAKAN</th>
                </tr>
              </thead>
              <tbody @click="handleClick"></tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /.content -->
</template>
<script>
import { createTable, authFetch, auth } from "@/libs/hxcore";
import Swal from "sweetalert2";
import $ from "jquery";
import 'jquery-ui';
import Daterangepicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";
import moment from "moment";

export default {
  name: "Ticket",
  data() {
    return {
        dateStart: moment().startOf("month").format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
        roles: "",
        filter: {
          status_approval: '',
          shipper_type: '',
          dt1: moment().startOf("month"),
          dt2: moment()
        },
        dt1: moment().startOf("month"),
        dt2: moment(),
    };
  },
  created: function () {
    this.roles = this.$route.meta.roles;
    this.userInfo = auth.user();
  },
  methods: {
    onDate() {
			this.table.api().ajax.reload();
		},
    handleClick(e) {
      if (e.target.matches(".link-order")) {
        let route = this.$router.resolve({
          path: "/shipper/verification/" + e.target.dataset.id
        });
        window.open(route.href,"_blank");
      }
    },
  },
  mounted() {
    const e = this.$refs;
    const self = this;

    new Daterangepicker(
      this.$refs.daterange,
      {
        startDate: !this.dt1 ? moment().day(-31) : this.dt1,
        endDate: !this.dt2 ? moment() : this.dt2,
        locale: {
            format: 'DD/MM/YYYY'
        }
      },
      function (d1, d2) {
        self.dateStart = d1.format("YYYY-MM-DD");
        self.dateEnd = d2.format("YYYY-MM-DD");
        self.filter.dt1 = self.dateStart;
        self.filter.dt2 = self.dateEnd;
        self.onDate();
      }
    );

    this.table = createTable(e.tblverif, {
      title: "",
      roles: this.roles,
      ajax: "/shipper/verification",
      frame: false,
      scrollX: true,
      autoWidth:false,
      deferRender : true,
      processing: true,
      language: {
        processing: '<i class="fa fa-spinner fa-spin" style="font-size:50px;color:black;"></i>'},
      selectedRowClass: "",
      toolbarEl: e.toolbar,
      lengthChange: true,
      filter: true,
      filterBy: [0, 1, 2, 3, 4],
      stateSave: true,
      paramData: function (d) {
        var filter = JSON.parse(JSON.stringify(self.filter));
        for (const key in filter) {
            d[key] = filter[key] === false ? 0: filter[key];
        }
      },
      order: [[ 4, 'desc' ]],
      columns: [
        {
          data: "shipper_code",
          render: function (data, type, row, meta) {
            return data + ' <div class="badge badge-' + (row.shipper_type == 1 ? 'agen' : 'cod') + '">bos' + (row.shipper_type == 1 ? 'Agen' : 'COD') + '</div>';
          },
        },
        { data: "nik" },
        { data: "nama" },
        { data: "nomor" },
        { data: "email" },
        {
          data: "ktp_verify_created",
          render: function (data, type, row, meta) {
              return moment(data).format("DD/MM/YYYY HH:mm:ss", true);
          },
        },
        {
          data: "ktp_verify",
          render: function (data, type, row, meta) {
            if (data == 0) return "-";
            else if (data == 1)
              return '<span class="badge badge-success">Approved</span>';
            else if (data == 2)
              return '<span class="badge badge-warning">Requested</span>';
            else if (data == 3)
              return '<span class="badge badge-danger">Rejected</span>';
            else return "-";
          },
        },
        {
          data: "id",
          sortable:false,
          render: function (data, type, row, meta) {
            return `<span class="link link-order text-info" style="cursor:pointer;" data-id="${data}">Lihat Detail</span>`;
          },
        },
      ],
      initComplete: function () {
        $('.loading-overlay').removeClass('show');
      },
    });
  },
};
</script>
<style>
.table-ticket .dataTables_scrollBody{min-height: 100px}
</style>